import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_4 = {
  key: 1,
  class: "ml-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("button", {
    class: "btn default-btn d-inline-block",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.buttonSubmit && _ctx.buttonSubmit(...args))),
    disabled: _ctx.buttonLoading ? _ctx.buttonLoading : false
  }, [
    (_ctx.buttonLoading)
      ? (_openBlock(), _createBlock("span", _hoisted_1, [
          _hoisted_2,
          _hoisted_3
        ]))
      : (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.buttonName), 1))
  ], 8, ["disabled"]))
}